module.exports = __webpack_public_path__ + "img/qrCodeOfOfficialAccount.27146f49.jpg";